import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-expired-page',
    templateUrl: './order-expired-page.component.html',
    styleUrls: ['./order-expired-page.component.scss'],
    standalone: false
})
export class OrderExpiredPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
